import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconEdit = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M21 19H11V21H21V19Z" }),
            React.createElement("path", { d: "M20.71 4.88008L19.12 3.29008C18.34 2.51008 17.07 2.51008 16.3 3.29008L3.59 16.0001C3.21 16.3801 3 16.8801 3 17.4101V21.0001H6.59C7.12 21.0001 7.63 20.7901 8 20.4101L20.71 7.71008C21.49 6.93008 21.49 5.66008 20.71 4.89008V4.88008ZM6.59 19.0001H5V17.4101L15 7.41008L16.59 9.00008L6.59 19.0001ZM18 7.59008L16.41 6.00008L17.7 4.71008L19.29 6.30008L18 7.59008Z" }))));
};
